/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ProductInputs */

const en_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const zh_hans1_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品`)
};

const pt_br2_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produto`)
};

const es_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto`)
};

const fr_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit`)
};

const de_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt`)
};

const ru_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продукт`)
};

const it_footer_product = /** @type {(inputs: Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodotto`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Footer_ProductInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_product = /** @type {((inputs?: Footer_ProductInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ProductInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_product(inputs)
	if (locale === "pt-BR") return pt_br2_footer_product(inputs)
	if (locale === "es") return es_footer_product(inputs)
	if (locale === "fr") return fr_footer_product(inputs)
	if (locale === "de") return de_footer_product(inputs)
	if (locale === "ru") return ru_footer_product(inputs)
	if (locale === "it") return it_footer_product(inputs)
	return en_footer_product(inputs)
});